<template>
  <div class="ion-text-right">
    <ion-grid class="ion-no-padding">
      <ion-row
        class="ion-justify-content-center"
        v-for="(option, optionKey) in question.options"
        :key="optionKey"
      >
        <ion-col>
          <ion-button
            fill="outline"
            class="ion-text-wrap"
            @click="emitValue(option)"
            v-if="option.id !== 'C' || zahn"
          >
            {{ getOptionValue(option.value) }}&nbsp;
            <ion-icon
              v-if="typeof option.icon === 'object'"
              slot="end"
              class="ion-margin-right"
              :src="require('@lib/assets/icons/' + option.icon.src)"
              :size="option.icon.size"
            ></ion-icon>
            <ion-icon v-else-if="option.icon" :icon="getIcon(option.icon)" />
          </ion-button>
        </ion-col>
        <ion-col size="auto" v-if="option.info">
          <ion-button fill="clear" @click="openInfoModal(option.info)"
            ><ion-icon slot="icon-only" :icon="helpCircleOutline"
          /></ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</template>

<script>
import {
  helpCircleOutline,
  thumbsUp,
  thumbsDown,
  call,
  calendar,
} from "ionicons/icons";
import {
  IonButton,
  IonGrid,
  IonRow,
  IonCol,
  IonIcon,
  modalController,
} from "@ionic/vue";
import InfoModal from "@lib/components/InfoModal";

export default {
  emits: ["done"],
  components: {
    IonButton,
    IonGrid,
    IonRow,
    IonCol,
    IonIcon,
  },
  props: {
    question: {
      required: true,
      type: Object,
    },
    zahn: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getOptionValue(value) {
      let result = value;
      if (this.zahn && result === "Persönlich mit einem Arzt vor Ort") {
        result = "Persönlich mit einem Zahnarzt vor Ort";
      }
      return result;
    },
    getIcon(icon) {
      return this[icon];
    },
    emitValue(option) {
      const value = {
        value: option.value,
        id: this.question.id,
      };
      if (option.id) {
        value.valueId = option.id;
      } else if (option.ids) {
        value.valueIds = option.ids;
      }
      if (option.checkName) {
        value.checkName = option.checkName;
      }
      this.$emit("done", value);
    },
    async openInfoModal(text) {
      const modal = await modalController.create({
        component: InfoModal,
        cssClass: "my-custom-class",
        componentProps: {
          text: text,
        },
      });
      return modal.present();
    },
  },
  setup() {
    return { helpCircleOutline, thumbsUp, thumbsDown, call, calendar };
  },
};
</script>

<style scoped>
ion-button {
  height: auto;
  --padding-bottom: 10px;
  --padding-top: 10px;
}
</style>
